import { format, isBefore, isEqual, startOfMonth } from "date-fns";
import { FC, useMemo } from "react";
import { useTodaysWebinars, useWebinarStore } from "../hooks/useWebinars";
import { today } from "../util/webinars";
import DisableOverlay from "./DisableOverlay";
import TodaysWebinars from "./TodaysWebinars";

export type DayProps = {
  day: Date;
};

const DayHeader: FC = ({ children }) => {
  return (
    <div className="tw-px-10 tw-font-medium tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center">
      {children}
    </div>
  );
};

const Day: FC<DayProps> = ({ day }) => {
  const topics = useWebinarStore((state) => state.topics);
  const credits = useWebinarStore((state) => state.credits);
  const webinars = useTodaysWebinars(day)
    .filter((webinar) => {
      if (topics.size > 0) {
        return topics.has(webinar.FieldOfStudyName!);
      }
      return true;
    })
    .filter((webinar) => {
      if (credits.size > 0) {
        if (webinar.ProductCredits >= 8) {
          return credits.has(8);
        }

        return credits.has(webinar.ProductCredits);
      }
      return true;
    });
  const dayOfWeek = format(day, "EEE");
  const dayOfMonth = format(day, "d");
  const month = format(day, "MMM");
  const isStartOfMonth = isEqual(startOfMonth(day), day);
  const isPastDate = useMemo((): boolean => isBefore(day, today()), [day]);

  // const selectedMonth = useStore((state) => state.selectedMonth.value);

  // const isPastDaysHidden =
  //   webinars.length === 0 &&
  //   !isThisWeek(day) &&
  //   today().getMonth() === selectedMonth;

  // ${isPastDaysHidden ? "tw-hidden" : "tw-block"}

  return (
    <div
      className={`tw-relative tw-border tw-min-h-[200px]  ${
        webinars.length > 0 ? "tw-bg-white" : ""
      } `}
    >
      {isPastDate && <DisableOverlay />}

      <div
        className={`tw-relative tw-z-0 tw-py-4 tw-flex tw-flex-col tw-items-center tw-text-tr-date ${
          isPastDate ? "tw-select-none tw-pointer-events-none" : ""
        }`}
      >
        <DayHeader>
          {/* {(weekIdx === 0 || !isPastDaysHidden) && ( */}
          <span className="tw-uppercase tw-text-sm tw-text-[#7E859D]">
            {dayOfWeek}
          </span>

          <span className="tw-text-2xl tw-text-[#3E4046]">
            {isStartOfMonth && month} {dayOfMonth}
          </span>
        </DayHeader>
        <TodaysWebinars webinars={webinars} day={day} />
      </div>
    </div>
  );
};

export default Day;
